import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule,PreloadAllModules} from '@angular/router';
import {AdminCrudComponent} from '../admin/components/admin-crud.component';
import {AdminComponent} from '../admin/components/admin.component';
import {DetailsComponent} from '../admin/components/details.component'
import {AdminService} from '../admin/services/admin.service'
import { FilterPipe } from '../../pipes/filter.pipe';
import {RoleGuardService} from '../../role-guard.service';
import {NgxPaginationModule} from 'ngx-pagination';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
const routes: Routes = [
    {path: 'admin', component: AdminComponent,canActivate :[RoleGuardService]},
    {path: 'admin/detail/:id', component: DetailsComponent,canActivate :[RoleGuardService]},
    {path: 'admin/create', component: AdminCrudComponent,canActivate :[RoleGuardService]},
    {path: 'admin/edit/:id', component: AdminCrudComponent,canActivate :[RoleGuardService]},
];


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgxPaginationModule,
        NgMultiSelectDropDownModule,
        RouterModule.forRoot(routes,
          {
            useHash: false,
            preloadingStrategy: PreloadAllModules
          }),
    ],
    exports: [RouterModule],
    providers:[AdminService],
    declarations: [AdminCrudComponent,AdminComponent,DetailsComponent,FilterPipe]
})

export class AdminModule {}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin.module.ts